{
  "version": 1,
  "asset_id": "20436f20-82d2-4038-8d92-d99fa9a9e54a",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/20436f20-82d2-4038-8d92-d99fa9a9e54a/mark-256.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/20436f20-82d2-4038-8d92-d99fa9a9e54a/mark-256.webp",
  "original_filename": "mark-256.webp",
  "size": 15230,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:18:26Z"
}
